import { render, staticRenderFns } from "./regisCoursesP.vue?vue&type=template&id=48954b54&"
import script from "./regisCoursesP.vue?vue&type=script&lang=js&"
export * from "./regisCoursesP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports